import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateOffer.css';

const SERVER_URL = process.env.REACT_APP_TEST_API_URL;

const CreateOffer = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      
      // Create preview URL
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setMessage({ text: 'Please select an image', type: 'error' });
      return;
    }
    
    setLoading(true);
    
    try {
      const submitData = new FormData();
      submitData.append('name', formData.name);
      submitData.append('description', formData.description);
      submitData.append('image', file); 
      
      const response = await fetch(`${SERVER_URL}/api/offer/create`, {
        method: 'POST',
        body: submitData,
        // No Content-Type header needed - browser sets it with boundary for multipart/form-data
      });
      
      if (response.ok) {
        setMessage({ text: 'Offer created successfully!', type: 'success' });
        // Navigate back to offers list after successful creation
        setTimeout(() => {
          navigate('/offers');
        }, 2000);
      } else {
        const error = await response.json();
        setMessage({ text: error.message || 'Failed to create offer', type: 'error' });
      }
    } catch (error) {
      setMessage({ text: 'An error occurred. Please try again.', type: 'error' });
      console.error('Form submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/offers');
  };

  return (
    <div className="create-offer-container">
      <div className="create-offer-form">
        <h2>Create New Offer</h2>
        
        {message.text && (
          <div className={`message ${message.type === 'success' ? 'success' : 'error'}`}>
            {message.text}
          </div>
        )}
        
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="form-group">
            <label htmlFor="name">Offer Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter offer name"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
              rows="4"
              placeholder="Describe your offer..."
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="image">Offer Image</label>
            <div className="image-upload-area">
              {preview ? (
                <div className="image-preview">
                  <img src={preview} alt="Preview" />
                </div>
              ) : (
                <div className="upload-placeholder">
                  <span>Click to select an image</span>
                </div>
              )}
              <input 
                type="file" 
                name="image"
                id="image"
                accept="image/*"
                onChange={handleImageChange}
                required
                className="file-input"
              />
            </div>
          </div>
          
          <div className="form-actions">
            <button 
              type="button" 
              className="cancel-btn" 
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`submit-btn ${loading ? 'loading' : ''}`}
            >
              {loading ? 'Creating...' : 'Create Offer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateOffer;